<template>
<div style="padding: 0 40px;">
  <order-content :orderObj="orderInfoObj"></order-content>
  <div class="flex-bg" style="margin-top: 20px">
    <div style="height: 32px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span>审核意见</span></div>
    <div class="info-name">
      <el-input class="my-form-inpt" size="small" v-model="dataForm.remark" placeholder="请输入审核意见"></el-input>
    </div>
  </div>
  <div style="margin-top: 20px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn1" @click="submitBtn(4)"><span>审核不通过</span></div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn1" @click="submitBtn(5)"><span>审核通过</span></div>
      </el-col>
    </el-row>
  </div>
  <div style="height: 30px"></div>
</div>
</template>
<script>
import {approvepersonsupplierservicecheckinfo} from '../../../api/serviceMark'
import orderContent from './orderContent.vue'

export default {
  name: 'orderDetails',
  model: {
    prop: 'openShow',
    event: 'change'
  },
  props: {
    orderObj: {
      type: Object
    }
  },
  components: {orderContent},
  data () {
    return {
      orderInfo: '',
      orderInfoObj: {
        row: '',
        type: 'order'
      },
      dataForm: {
        remark: ''
      }
    }
  },
  created () {
    this.orderInfo = this.orderObj.row
    this.orderInfoObj.row = this.orderObj.row
  },
  methods: {
    closeOpen () {
      this.$emit('change', false)
    },
    submitBtn (val) {
      let data = {
        id: this.orderInfo.id,
        checkinfo_remark: this.dataForm.remark,
        checkinfo_sys_person_id: this.$store.state.user.LoginResp.syspersonid,
        is_tag: val,
        pss_id: this.orderInfo.pss_id
      }
      if (this.dataForm.remark === '') {
        this.$message({ message: '请输入审核意见。', type: 'warning' })
        return
      }
      approvepersonsupplierservicecheckinfo(data).then(res => {
        this.$notify({ title: '成功', message: '成功审核服务单', type: 'success', duration: 2000 })
        this.$emit('changeTable')
        this.$emit('change', false)
      })
    }
  }
}
</script>

<style scoped>
.flex-bg{
  display: flex;
  min-height: 34px;
  margin-bottom: 5px;
}
.info-name{
  font-family: PingFang SC, PingFang SC;
  font-size: 16px;
  color: #3D3D3D;
  box-sizing: border-box;
  flex: 1;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/orderDetails.vue